var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* eslint-disable @typescript-eslint/naming-convention */
import BasePlayer from '../base/base-player';
import { VALID_STATE_IN_LEVEL_SWITCHING } from '../base/state-mgr';
import { END_STATE, ERROR_CODE, KERNEL_NAME, PAUSE_TYPE, PLAY_EVENT, SET_LEVEL_MODE, VIDEO_NODE_EVENT, VIDEO_STATE, } from '../enums';
import SimpleDefer from '../libs/simple-defer';
import { domTool, logMethodCallDecoratorCreator, videoTool } from '../util';
import { mergeKernelConfig } from './default-config';
import OrgPreLoader from './org-preloader';
var logMethodCall = logMethodCallDecoratorCreator('MultiPlayer');
/**
 * 用多个video标签切换播放一个列表。
 */
var MultiPlayer = /** @class */ (function (_super) {
    __extends(MultiPlayer, _super);
    function MultiPlayer(conf) {
        var _a;
        var _this = _super.call(this, mergeKernelConfig(conf)) || this;
        _this._needHideVideoNode = null;
        _this._videonodeEventMap = (_a = {},
            _a[VIDEO_NODE_EVENT.STATE_CHANGE] = _this.onCurVideoNodeStateChange.bind(_this),
            _a);
        return _this;
    }
    Object.defineProperty(MultiPlayer, "canPlayType", {
        get: function () {
            return videoTool.supportVideoFormat();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiPlayer.prototype, "supportPreload", {
        get: function () {
            return videoTool.supportSameTimePlay();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiPlayer.prototype, "kernelName", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return KERNEL_NAME.ORIGIN;
        },
        enumerable: false,
        configurable: true
    });
    MultiPlayer.prototype.seek = function (time) {
        if (this.getLevelSwitching()) {
            // multiplayer内切换清晰度为soft切换，这种也是暂停切换，过程中无法seek
            return false;
        }
        return _super.prototype.seek.call(this, time);
    };
    MultiPlayer.prototype.createVideoNodes = function (count) {
        _super.prototype.createVideoNodes.call(this, count);
        for (var i = 0; i < this._vnList.length; i++) {
            var vn = this._vnList[i];
            if (i === 0) {
                // 第一个video标签直接显示出来（如果有设置poster，可以展示）
                this._firstVideoNode = vn;
            }
            else {
                this.visibleVideoNode(vn, false);
            }
        }
    };
    MultiPlayer.prototype.videonodeEventHandler = function (e) {
        // 先进行内部事件处理，完了以后再发出事件（因为发出事件以后外部可能stop或者销毁事件）
        if (this._videonodeEventMap[e.type]) {
            this._videonodeEventMap[e.type](e);
        }
        _super.prototype.videonodeEventHandler.call(this, e);
    };
    MultiPlayer.prototype.onCurVideoNodeStateChange = function (e) {
        if (e.data.new !== VIDEO_STATE.PLAYING) {
            return;
        }
        this.switchVideoNode();
        // 通知外部当前视频已经开播了
        if (!this.currentVideoInfo.extraVars.isStartPlay) {
            this.currentVideoInfo.extraVars.isStartPlay = true;
            var uid = this.currentVideoInfo ? this.currentVideoInfo.uid : null;
            this._logger.log("videoNodeStartPlay: uid[".concat(uid, "]"));
            this.emit(PLAY_EVENT.VIDEONODE_START_PLAY, { videoInfo: this.currentVideoInfo });
        }
    };
    MultiPlayer.prototype.onVideoNodeStateChange = function (e) {
        if (this.getLevelSwitching() && !VALID_STATE_IN_LEVEL_SWITCHING.includes(e.data.new)) {
            // 在multiplayer里切换清晰度触发时，已经将下一个VideoNode设置为currentVideoNode（开始监听此VideoNode事件）。在切换过程中，需要
            // 过滤掉currentVideoNode的状态变化。
            return false;
        }
        return _super.prototype.onVideoNodeStateChange.call(this, e);
    };
    MultiPlayer.prototype.pauseInner = function (type) {
        if (type === void 0) { type = PAUSE_TYPE.INNER; }
        if (this._prePlayNext) {
            // 提前开始播放下一个，就是在准备切换了。这个极短的时间里面，不允许暂停了
            this._logger.warn('pause when preplaynext, return!!');
            return;
        }
        _super.prototype.pauseInner.call(this, type);
    };
    MultiPlayer.prototype.resumeInner = function () {
        if (this.getLevelSwitching()) {
            // 如果正在切清晰度的时候被暂停了（比如在手机上切到后台，系统暂停了所有video的播放），恢复play的时候只恢复切清晰度的
            this._setLevelVideoNode.play();
            return;
        }
        _super.prototype.resumeInner.call(this);
    };
    MultiPlayer.prototype.loadInner = function (value, extra) {
        var _a;
        var vnLen = ((_a = this._vnList) === null || _a === void 0 ? void 0 : _a.length) || 0;
        for (var i = 0; i < vnLen; i++) {
            this.visibleVideoNode(this._vnList[i], false);
        }
        return _super.prototype.loadInner.call(this, value, extra);
    };
    MultiPlayer.prototype.playInner = function (startTime) {
        if (!this.checkBeforePlay()) {
            return;
        }
        this.playStartTime = startTime;
        var videoInfo = this._videoInfos[this._curUrlIdx];
        var preloaderIdx = this.findPreloadIdxByVideoInfo(videoInfo);
        if (preloaderIdx !== -1) {
            // 如果有预加载，处理preload后进入play
            this.preloadToPlay(videoInfo, preloaderIdx);
        }
        else if (videoInfo.error) {
            // 如果加载出错，进入错误处理
            this._logger.log('play(), got preload error');
            this.stopInner(END_STATE.ERROR, true, videoInfo);
        }
        else {
            // 如果没有预加载，直接进入播放调用
            this.enterVideoNodePlay(videoInfo);
        }
    };
    MultiPlayer.prototype.visibleVideoNode = function (vn, value) {
        var _a;
        if (!(vn === null || vn === void 0 ? void 0 : vn.videoElement)) {
            return;
        }
        this.setVideoElementState(vn.videoElement, value);
        this._logger.log(">>>visibleVideoNode<<<, value=".concat(value, "/uid=").concat((_a = vn.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.uid));
    };
    MultiPlayer.prototype.setVideoElementState = function (videoElement, value) {
        var tarVolume = value ? this._volume : 0;
        if (videoElement.volume !== tarVolume) {
            videoElement.volume = tarVolume;
        }
        // 当video标签切换到前台准备播放，此时需要恢复静音，但一定要先看看当前音量是不是本来就是静音的（用户设置了静音）
        // 此时不需要恢复静音，而是继续保持静音状态
        var tarMuted = this._volume <= 0 || !value;
        if (videoElement.muted !== tarMuted) {
            videoElement.muted = tarMuted;
        }
        domTool.css(videoElement, 'zIndex', value ? '0' : '-1');
        domTool.css(videoElement, 'visibility', value ? 'inherit' : 'hidden');
    };
    MultiPlayer.prototype.switchVideoNode = function () {
        // 有需要隐藏的video标签 && 隐藏的目标video标签不是当前播放的video标签，才进行切换
        if (!this._needHideVideoNode || this._curVideoNode === this._needHideVideoNode) {
            return;
        }
        this._logger.log('>>>>>switchVideoNode<<<<<');
        this.visibleVideoNode(this._curVideoNode, true);
        // 被隐藏的延迟一下隐藏，不然ios可能会黑闪
        var vnn = this._needHideVideoNode;
        this.visibleVideoNode(vnn, false);
        if (vnn) {
            vnn.stop();
        }
        this._needHideVideoNode = null;
    };
    MultiPlayer.prototype.playNextInner = function (opts) {
        // 先记录一下需要隐藏的上一个播放控件（不立即隐藏的原因是移动端等平台可能会在切换video标签的过程中出现一下黑屏）
        this._needHideVideoNode = this._curVideoNode;
        this._prePlayNext = false;
        _super.prototype.playNextInner.call(this, opts);
    };
    MultiPlayer.prototype.appendAfter = function (videoInfo) {
        // 只需要检查被append进来的数组的第一个视频信息，看看是否需要马上播放她或者干点别的
        var isIdle = this._curVideoNode ? this._curVideoNode.state === VIDEO_STATE.IDLE : true;
        // 如果被检查的视频信息就是当前播放的下一个视频信息
        if (this._played && this._curUrlIdx + 1 === this._videoInfos.indexOf(videoInfo) && isIdle) {
            this.playNextInner();
        }
    };
    MultiPlayer.prototype.preparePreloader = function (isFirstLoad, videoInfo) {
        this._logger.log('preparePreloader(), isFirstLoad=', isFirstLoad);
        var videoNode = this.getIdleVideoNode();
        if (!videoNode) {
            // 已经找不到空闲的IVideoNode了
            return null;
        }
        videoInfo.extraVars.preloadVideoNode = videoNode;
        // 如果是第一个预加载，直接显示出来并设置成当前播放的VideoNode(用于派发事件出去)
        if (isFirstLoad) {
            this.setCurVideoNode(videoNode);
            this.visibleVideoNode(videoNode, true);
        }
        return new OrgPreLoader(this._config);
    };
    MultiPlayer.prototype.getIdleVideoNode = function () {
        if (this._firstVideoNode) {
            // 有指定第一个使用的videonode，就直接返回
            var vn = this._firstVideoNode;
            this._firstVideoNode = null;
            return vn;
        }
        var ret = null;
        var len = this._vnList.length;
        for (var i = 0; i < len; i++) {
            if (this._vnList[i].state === VIDEO_STATE.IDLE && this._vnList[i] !== this._curVideoNode) {
                var arr = this._vnList.splice(i, 1);
                ret = arr[0];
                break;
            }
        }
        if (ret) {
            this._vnList.push(ret);
        }
        return ret;
    };
    /** 是否正在切换清晰度（在multi-player中实现的soft切换）*/
    MultiPlayer.prototype.getLevelSwitching = function () {
        return !!this._setLevelVideoNode;
    };
    MultiPlayer.prototype.setLevelInner = function (value) {
        var setLevelMode = this.decideSetLevelMode(value === null || value === void 0 ? void 0 : value.setLevelMode);
        this._logger.log("setLevelMode=".concat(setLevelMode));
        if (setLevelMode === SET_LEVEL_MODE.HARD || setLevelMode === SET_LEVEL_MODE.SMOOTH) {
            // VideoNode自行处理硬切还是平滑切换
            return this._curVideoNode.setLevel(setLevelMode);
        }
        return this.setLevelSoftMode();
    };
    /**
     * 下一个清晰度的VideoNode播放ok以后，切换到前台开始播放
     * @param preVideoNode 上一个清晰度播放时使用的VideoNode
     */
    MultiPlayer.prototype.switchVideoNodeWhenSetLevelSucc = function (preVideoNode) {
        this._logger.log('>>>>>switchLevelVideoNode<<<<<');
        if (preVideoNode === this._curVideoNode) {
            // 下一个清晰度的VideoNode就是当前的VideoNode，直接显示出来
            this.visibleVideoNode(this._curVideoNode, true);
        }
        else {
            this.visibleVideoNode(this._curVideoNode, true);
            this.visibleVideoNode(preVideoNode, false);
            preVideoNode === null || preVideoNode === void 0 ? void 0 : preVideoNode.stop();
        }
    };
    MultiPlayer.prototype.checkAccuratePlaytime = function (videoElementTime, videoElementDuration) {
        var _a, _b;
        var prePlayNextTime = this._config.originKernelConfig.prePlayNextTime;
        var leftTime = Math.abs(videoElementDuration - videoElementTime);
        if (prePlayNextTime > 0 && leftTime < prePlayNextTime && !this._prePlayNext) { // 提前开播下一个
            this._prePlayNext = true;
            var preloaderIdx = this.findPreloadIdxByVideoInfo(this.nextVideoInfo);
            if (this.nextVideoInfo && preloaderIdx !== -1) {
                var existPreloadVideoNode = (_b = (_a = this._preloaders[preloaderIdx]) === null || _a === void 0 ? void 0 : _a.videoInfo) === null || _b === void 0 ? void 0 : _b.extraVars.preloadVideoNode;
                if (existPreloadVideoNode) {
                    this._logger.log("preplay next!! idx/state: ".concat(existPreloadVideoNode.idx, "/").concat(existPreloadVideoNode.state));
                    existPreloadVideoNode.play();
                }
            }
        }
        this.checkAutoPreloadNext(leftTime);
    };
    MultiPlayer.prototype.stopInner = function (endState, dispatchEvt, videoInfo) {
        if (endState === void 0) { endState = END_STATE.NORMAL; }
        if (dispatchEvt === void 0) { dispatchEvt = false; }
        if (videoInfo === void 0) { videoInfo = null; }
        this._firstVideoNode = null;
        this._prePlayNext = false;
        this.playStartTime = 0;
        // 如果有正在切换清晰度的videoNode，也得清理
        this.clearSetLevelThings(true);
        _super.prototype.stopInner.call(this, endState, dispatchEvt, videoInfo);
    };
    MultiPlayer.prototype.destroy = function () {
        this._needHideVideoNode = null;
        this._setLevelVideoNode = null;
        this._firstVideoNode = null;
        this.playStartTime = 0;
        // 缓存一下，避免super.destroy以后为空
        var videoElement = this.videoElements;
        _super.prototype.destroy.call(this);
        // 因video标签是外部传入并且复用的，不是本对象自己创建的，因此需要恢复原样
        videoElement.forEach(function (e) {
            if (!(e instanceof HTMLVideoElement)) {
                return;
            }
            // 切换video标签到后台预加载等逻辑时，可能会修改video标签的如下属性，恢复修改
            e.volume = 1;
            e.muted = false;
            domTool.css(e, {
                zIndex: '0',
                visibility: 'inherit',
            });
            e.dataset.idx = '0';
        });
    };
    /** 播放接口调用前置检查 */
    MultiPlayer.prototype.checkBeforePlay = function () {
        if (this.getLevelSwitching()) {
            // todo： 如果正在切换清晰度的时候，触发了打断式加载，怎么做？
            // 如果正在切清晰度的时候被暂停了（比如在手机上切到后台，系统暂停了所有video的播放），恢复play的时候只恢复切清晰度的
            this._setLevelVideoNode.play();
            this._logger.log('play(), setlevel');
            return false;
        }
        if (this._videoInfos.length <= 0 || !this._videoInfos[this._curUrlIdx]) {
            this._logger.warn('play(), !videoInfo');
            return false;
        }
        return true;
    };
    /**
     * 发送STATE_CHANGE事件
     * @param videoInfo 发送对应的IVideoInfo信息对象
     * @param newState Change后播放状态
     */
    MultiPlayer.prototype.emitStateChange = function (videoInfo, newState) {
        this.emit(PLAY_EVENT.STATE_CHANGE, {
            videoInfo: videoInfo,
            new: newState,
            old: this._curVideoNode ? this._curVideoNode.state : VIDEO_STATE.IDLE,
        });
    };
    /**
     * 处理下一个视频从preload状态转化为play
     * @param videoInfo 预加载videoInfo对象
     * @param preloaderIdx 预加载loader序号
     */
    MultiPlayer.prototype.preloadToPlay = function (videoInfo, preloaderIdx) {
        var _this = this;
        var DELAY_BUFFERING_TIME = 200;
        var preloadBufferingTimeoutID = 0;
        // 如果即将播放下一个视频，但是又处于预加载中，需要给一个buffering事件出去
        if (videoInfo.hasFirstPlaying) {
            preloadBufferingTimeoutID = window.setTimeout(function () {
                _this.emitStateChange(videoInfo, VIDEO_STATE.BUFFERING);
            }, DELAY_BUFFERING_TIME);
        }
        this._preloaders[preloaderIdx].promise.then(function () {
            clearTimeout(preloadBufferingTimeoutID);
            _this._logger.log("play(), preloadVideoNode succ, uid=".concat(videoInfo.uid));
            _this.enterVideoNodePlay(videoInfo, preloaderIdx);
        }).catch(function (error) {
            _this._logger.log("play(), preloadVideoNode error, uid=".concat(videoInfo.uid, "/error="), error);
            if (!(error.code in ERROR_CODE)) {
                // 所谓鸭子类型判断，因为可能有各种其他的不是播放器定义的错误
                return;
            }
            clearTimeout(preloadBufferingTimeoutID);
            // 预加载时候已经把备份地址重试完了，没必要继续了
            // 所以下面直接抛出错误
            videoInfo.error = error;
            _this.stopInner(END_STATE.ERROR, true, videoInfo);
        });
    };
    /**
     * 最终进入调用videonode的play逻辑
     * @param videoInfo 进入播放videoInfo对象
     * @param preloaderIdx 已经预加载序号
     */
    MultiPlayer.prototype.enterVideoNodePlay = function (videoInfo, preloaderIdx) {
        var _a, _b, _c;
        if (preloaderIdx === void 0) { preloaderIdx = -1; }
        var preloadSucc = preloaderIdx !== -1;
        this._logger.log("enterVideoNodePlay(), preloadSucc=".concat(preloadSucc));
        var existPreloadVideoNode = preloaderIdx !== -1
            ? (_b = (_a = this._preloaders[preloaderIdx]) === null || _a === void 0 ? void 0 : _a.videoInfo) === null || _b === void 0 ? void 0 : _b.extraVars.preloadVideoNode : null;
        this.findIdleVideoNode(existPreloadVideoNode);
        // 如果被预加载过，清理预加载信息，但是保留video上已加载的数据
        if (preloaderIdx !== -1) {
            var preloader = this._preloaders.splice(preloaderIdx, 1)[0];
            preloader.clear(true);
        }
        // 如果是自动播放的场景，这里有个注意点哦！
        // 我们需要在调用play之前就把videonode显示出来（调用visibleVideoNode传true使volume设置为正常状态），否则是静音状态的时候调用了
        // play方法（见下面代码的videonode.play方法）。如果是静音状态时候调用play就无法catch到自动播放被阻止的异常了。而是调用play再恢复音
        // 量时，会收到类似如下警告（chrome）：
        // Unmuting failed and the element was paused instead because the user didn't interact with the document before
        // 这种情况不是我们预期的检测自动播放结果。因此把下面这一段代码移上来了。
        if (!this._needHideVideoNode) {
            // 不需要等上一个隐藏，那就直接显示。否则需要等一定时机显示出来
            this.visibleVideoNode(this._curVideoNode, true);
            this._logger.log('visibleVideoNode, null need');
        }
        else if (this._needHideVideoNode === this._curVideoNode) {
            this.visibleVideoNode(this._curVideoNode, true);
            this._logger.log('visibleVideoNode, need==current');
        }
        else if (preloadSucc) {
            this.switchVideoNode();
        }
        if (this._curVideoNode.state !== VIDEO_STATE.PLAYING) {
            this._curVideoNode.play(videoInfo, { startTime: this.playStartTime });
        }
        this.emit(PLAY_EVENT.VIDEONODE_CHANGE, { videoInfo: this.currentVideoInfo });
        this._logger.log("enterMultiPlay(), uid=".concat((_c = this.currentVideoInfo) === null || _c === void 0 ? void 0 : _c.uid, "/")
            + "urlIdx=".concat(this._curUrlIdx, "/state=").concat(this._curVideoNode.state));
        if (!preloadSucc) {
            // 如果没有预加载，不需要补发事件了
            return;
        }
        // 如果不是第一个视频播放，并且被预加载过，可能需要补发一些事件
        if (this._videoInfos.indexOf(this.currentVideoInfo) !== 0) {
            // 如果url有预加载，duration变化事件已经错过了，这里补发一个事件给外部（放在videoNode.play以后触发，才能取到currentVideoInfo属性）
            this.emit(PLAY_EVENT.DURATION_CHANGE, { videoInfo: this.currentVideoInfo });
            // 因为可能提前开播了，补一个playing事件
            this.emitStateChange(this.currentVideoInfo, this._curVideoNode.state);
        }
        // 通知外部当前视频已经开播了
        if (!this.currentVideoInfo.extraVars.isStartPlay) {
            this.currentVideoInfo.extraVars.isStartPlay = true;
            this._logger.log("videoNodeStartPlay: uid[".concat(this.currentVideoInfo.uid, "]"));
            this.emit(PLAY_EVENT.VIDEONODE_START_PLAY, { videoInfo: this.currentVideoInfo });
        }
    };
    /** 查找当前空闲的VideoNode */
    MultiPlayer.prototype.findIdleVideoNode = function (existPreloadVideoNode) {
        // 下面开始选择一个播放控件
        var idleVideoNode;
        var forceSetVideoNode = false;
        // 先看是否有预加载
        idleVideoNode = existPreloadVideoNode;
        // 如果为空，再看是否有空闲videonode
        if (!idleVideoNode) {
            idleVideoNode = this.getIdleVideoNode();
        }
        // 如果为空，再看当前videonode是否是空闲状态
        if (!idleVideoNode && this._curVideoNode && this._curVideoNode.state === VIDEO_STATE.IDLE) {
            idleVideoNode = this._curVideoNode;
            // 此时需要强制替换当前videonode
            forceSetVideoNode = true;
        }
        if (!idleVideoNode) {
            this._logger.warn('can not find idle videonode!');
            throw new Error('can not find idle videonode!');
        }
        this.setCurVideoNode(idleVideoNode, forceSetVideoNode);
    };
    /**
     * 实现soft模式的清晰度切换
     */
    MultiPlayer.prototype.setLevelSoftMode = function () {
        var _this = this;
        // 以下逻辑为multi-player实现soft模式的清晰度切换：
        var levelSwitchingDefer = new SimpleDefer();
        // 先把当前的VideoInfo存起来。因为如果找不到可以使用的空闲VideoNode，可能会销毁当前的VideoNode来实现清晰度切换，这样会导致
        // currentVideoInfo变量为空
        var videoInfo = this.currentVideoInfo;
        this._logger.log("setLevelInner(), uid: ".concat(videoInfo.uid));
        this.pauseInner();
        this.setPlayEvents(this._curVideoNode, false);
        this.emit(PLAY_EVENT.SETLEVEL_START, { videoInfo: videoInfo, mode: SET_LEVEL_MODE.SMOOTH });
        // multi-player切换清晰度不使用VideoNode的setLevel方法，而是自己实现的多video切换，因此切换前先显示loading动画
        this.setLoading(true);
        var targetPlaytime = this._curVideoNode.playtime;
        var videoNode = this.getIdleVideoNode();
        // 找一个空闲的videoNode来加载下一个清晰度，如果没有，只能清理当前的videoNode了（会黑屏）
        if (!videoNode) {
            this._curVideoNode.stop();
            videoNode = this._curVideoNode;
        }
        else {
            this.visibleVideoNode(videoNode, false);
        }
        // url需要重新加载
        videoInfo.extraVars.isLoadstarted = false;
        this._setLevelVideoNode = videoNode;
        this._setLevelVideoNode.setLevelEvtMap = {}; // 切换清晰度事件
        // 在触发切换的时候，就设置下一个清晰度的VideoNode为currentVideoNode，开始监听下一个清晰度的事件。而上一个清晰度的VideoNode仅为了保
        // 留画面，不再开始监听事件、控制其行为。
        var preVideoNode = this._curVideoNode;
        this.setCurVideoNode(videoNode, true);
        videoNode.setLevelEvtMap[VIDEO_NODE_EVENT.STATE_CHANGE] = function (e) {
            // 下一个清晰度视频开播，代表切换成功
            if (e.data.new === VIDEO_STATE.PLAYING) {
                _this.setLevelSoftModeHandler(videoInfo, levelSwitchingDefer, preVideoNode);
            }
        };
        videoNode.setLevelEvtMap[VIDEO_NODE_EVENT.ERROR] = function (e) {
            _this.setLevelSoftModeHandler(videoInfo, levelSwitchingDefer);
        };
        // timeupdate是等待新的清晰度时间超过切换清晰度的时间时结束，这样可能会比较慢
        videoNode.on(VIDEO_NODE_EVENT.STATE_CHANGE, videoNode.setLevelEvtMap[VIDEO_NODE_EVENT.STATE_CHANGE]);
        videoNode.on(VIDEO_NODE_EVENT.ERROR, videoNode.setLevelEvtMap[VIDEO_NODE_EVENT.ERROR]);
        // 直接播放下一个清晰度的视频
        videoNode.play(videoInfo, { startTime: targetPlaytime });
        return levelSwitchingDefer.promise;
    };
    /** 清除预加载相关资源，包括移除事件和相关数据等，注意如果正在切换清晰度中不会执行清理  */
    MultiPlayer.prototype.clearSetLevelThings = function (keepdata) {
        if (!this.getLevelSwitching()) {
            return;
        }
        var videoNode = this._setLevelVideoNode;
        if (videoNode.setLevelEvtMap) {
            Object.keys(videoNode.setLevelEvtMap).forEach(function (evt) {
                videoNode.off(evt, videoNode.setLevelEvtMap[evt]);
            });
            videoNode.setLevelEvtMap = null;
        }
        if (!keepdata) {
            videoNode.stop();
        }
        // 清晰度切换成功以后，强制清理掉所有的预加载数据
        this.clearAllPreloadInner();
        this._setLevelVideoNode = null;
    };
    MultiPlayer.prototype.setLevelSoftModeHandler = function (videoInfo, levelDefer, preVNode) {
        var _a;
        if (preVNode === void 0) { preVNode = null; }
        var succ = !!preVNode;
        this._logger.log("setLevel succ>>>>>> ".concat(succ, " uid: ").concat(videoInfo.uid));
        this.clearSetLevelThings(succ);
        if (succ) {
            this.switchVideoNodeWhenSetLevelSucc(preVNode);
            levelDefer.resolve();
        }
        else {
            this.rollbackLevelVideoNode();
            levelDefer.reject(new Error("setLevel failed, ".concat((_a = videoInfo.error) === null || _a === void 0 ? void 0 : _a.message)));
        }
        this.emit(PLAY_EVENT.SETLEVEL_OVER, { videoInfo: videoInfo, fail: !succ });
        this.setLoading(false);
    };
    /** 清晰度切失败了得回滚，不然就卡死了 */
    MultiPlayer.prototype.rollbackLevelVideoNode = function () {
        this._logger.log('>>>>>rollbackLevelVideoNode<<<<<');
        if (this._urlBeforeSetLevel) {
            // 回滚时候恢复切换之前的url地址（并重置loadingUrl等）
            Object.assign(this.currentVideoInfo.config, this._urlBeforeSetLevel);
            this.currentVideoInfo.reset();
            this._urlBeforeSetLevel = null;
        }
        this.setPlayEvents(this._curVideoNode, true);
        this.resumeInner();
    };
    // 原生播放返回true，如果继承MultiPlayer的内核需要重写该方法
    MultiPlayer.isEnvSupport = true;
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], MultiPlayer.prototype, "playInner", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MultiPlayer.prototype, "switchVideoNode", null);
    return MultiPlayer;
}(BasePlayer));
export default MultiPlayer;
